<span class="cmdk-row__icon" aria-hidden="true">
  <paper-icon [name]="icon()" [size]="20" />
</span>

<span class="cmdk-row__text">
  <span class="cmdk-row__title">{{ item().title }}</span>
  @if (item().subtitle) {
    <span class="cmdk-row__subtitle">{{ item().subtitle }}</span>
  }
</span>

@if (tagLabel(); as label) {
  <paper-tag class="cmdk-row__tag" [intent]="tagIntent()" size="sm">{{ label }}</paper-tag>
}

@if (quickOpenKey(); as digit) {
  <paper-kbd class="cmdk-row__quick" [keys]="digit" [mod]="true" size="sm" />
}
